import React from 'react'
import styles from './styles.module.css'
import get from 'lodash/get'

export default function BrandBar(props) {
  const imgSrc = get(props, 'brand.categoriesImage.url')

  return imgSrc ? (
    <img className={styles.image} onClick={props.onClick} src={props.brand.categoriesImage.url} />
  ) : null
}
